import Config from '@/config'

import API from './base'

class CardAPI extends API {
  tokenize = ({
    number,
    expiryMonth,
    expiryYear,
    cvv,
    customerId,
    auditRules,
  }) => {
    return this.fetcher(
      {
        baseUrl: Config.payBaseUrl,
        trackingKey: 'tokens',
        method: 'POST',
        path: '/tokens',
        data: {
          type: 'card',
          number,
          expiry_month: expiryMonth,
          expiry_year: expiryYear,
          cvv,
          audit_rules: auditRules,
        },
      },
      {
        options: {
          headers: {
            'x-merchant-pk': Config.tamaraMerchantPk,
            'x-customer-id': customerId,
          },
        },
      }
    )
  }
}

export default new CardAPI('')
